import { z } from "zod";

export const TutorialCueStateSchema = z.enum(["Dismissed", "Completed"]);
export const TutorialCuePreferenceSchema = z.object({
  tutorialId: z.string().min(1),
  cueId: z.string().min(1),
  contentVersion: z.number().int().positive(),
  state: TutorialCueStateSchema,
});
export const TutorialPreferencesSchema = z.object({
  enabled: z.boolean(),
  cues: z.array(TutorialCuePreferenceSchema),
});

export type TutorialCueState = z.infer<typeof TutorialCueStateSchema>;
export type TutorialCuePreference = z.infer<typeof TutorialCuePreferenceSchema>;
export type TutorialPreferencesJSON = z.infer<typeof TutorialPreferencesSchema>;
